<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { fetchData, } from '../components/shared/utils/Data.svelte';
  import { Edit, Nav, Login } from '../components/account';
  import { create, contact } from 'ionicons/icons/index.mjs';
  export let data;
  let account = data.account;
  let token = data.token;
  let modal = false;
  let edit = false;
  let field = "";
  let value = "";
  let referrer = localStorage.getItem("referrer") || "";

  onMount(() => {
    if (account && account.referrer) {
      if (account.referrer.startsWith("https://geosync.cloud"))
        referrer = "https://start.geosync.cloud";
      else
        referrer = account.referrer;
    }
    else if (!referrer) {
      if (document.referrer.startsWith("https://geosync.cloud"))
        referrer = "https://start.geosync.cloud";
      else
        referrer = document.referrer;
      localStorage.setItem("referrer", referrer);
    }
  })

  async function messageHandler(message) {
		if (message.detail.type == "modal") {
      modal = !modal;
    }
    else if (message.detail.type == "edit") {
      field = "";
      value = "";
      edit = !edit;
    }
    else if (message.detail.type == "save") {
      var data = message.detail.data;
      let [res, err] = await fetchData("/account/edit", {
        method: "POST",
          headers: {
              'Accept': 'application/json'
          },
          body: data
      });
      if (!err) {
        account[data.get("field")] = data.get("value");
      }
      field = "";
      value = "";
      edit = false;
    }
  }
  function editHandler(name) {
    field = name;
    value = account[name];
    edit = !edit;
  }
</script>

<div class="container grid-xl" in:fade>
  <Login modal={modal} referrer={referrer} on:message={messageHandler} />
  <Edit edit={edit} field={field} value={value} on:message={messageHandler} />
  <Nav page="Account" account={account} referrer={referrer} on:message={messageHandler} />
  {#if account}
  <div class="columns">
    <div class="column col-sm-12 col-6">
        <div class="card">
        <div class="card-body">
            <h6>Details</h6>
        </div>
        <div class="card-body">
        <table class="table table-striped">
            <tbody>
                <tr>
                <th>Account ID</th>
                <td>{account.id}</td>
                </tr>
                <tr>
                <th>Account Type</th>
                <td>{account.type}</td>
                </tr>
                {#if account.expiration}
                <tr>
                <th>Expiration</th>
                <td>{account.expiration}</td>
                </tr>
                {/if}
                {#if account.code}
                <tr>
                <th>Code</th>
                <td>{account.code}</td>
                </tr>
                {/if}
                <tr>
                <th>Name</th>
                <td><div class="contact-field">{account.name}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("name");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
                <tr>
                <th>Company</th>
                <td><div class="contact-field">{account.company}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("company");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
                <tr>
                <th>Street</th>
                <td><div class="contact-field">{account.street}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("street");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
                <tr>
                <th>City</th>
                <td><div class="contact-field">{account.city}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("city");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
                <tr>
                <th>State</th>
                <td><div class="contact-field">{account.state}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("state");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
                <tr>
                <th>Zip Code</th>
                <td><div class="contact-field">{account.zip}</div><div class="float-right"><button on:click={(e) => {
											e.currentTarget.blur();
											editHandler("zip");
										}} class="btn btn-link"><i class="svg">{@html create.md}</i></button></div></td>
                </tr>
            </tbody>
        </table>
        </div>
        </div>
    </div>
      {#if account.admin_limit}
      <div class="column col-sm-12 col-6">
        <div class="card">
          <div class="card-body">
              <div class="tile tile-centered">
              <div class="tile-content">
                  <div class="card-title h6">Publisher</div>
              </div>
              <div class="tile-action">
                  <a href="https://geosync.blob.core.windows.net/publisher/Releases/Setup.exe" class="btn btn-primary">Download</a>
              </div>
              </div>
          </div>
          <div class="card-body">
            <div>Publishers ({ Math.round(account.admin_count / account.admin_limit * 100) }%)</div>
            <div class="bar">
                <div class="bar-item" role="progressbar" style="width:{account.admin_count / account.admin_limit * 100}%;" aria-valuenow="{account.admin_count / account.admin_limit * 100}" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="mb-2">{account.admin_count} / {account.admin_limit}</div>
            <div class="mt-2">Storage ({ Math.round(account.storage_count / account.storage_limit * 100) }%)</div>
            <div class="bar">
                <div class="bar-item" role="progressbar" style="width:{account.storage_count / account.storage_limit * 100}%;" aria-valuenow="{account.storage_count / account.storage_limit * 100}" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="mb-2">{ (account.storage_count / 1024 / 1024 / 1024).toFixed(2) } GB / { Math.round(account.storage_limit / 1024 / 1024 / 1024) } GB</div>
            <div class="mt-2">Maps ({ Math.round(account.map_count / account.map_limit * 100) }%)</div>
            <div class="bar">
                <div class="bar-item" role="progressbar" style="width:{account.map_count / account.map_limit * 100}%;" aria-valuenow="{account.map_count / account.map_limit * 100}" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="mb-2">{account.map_count} / {account.map_limit}</div>
          </div>
        </div>
        <div class="empty">
          <p class="empty-title h5">To upgrade your account, visit the store using the link below:</p>
          <div class="empty-action">
            <a href="/account/subscription" class="btn btn-primary" style="width:200px;">Store</a>
          </div>
        </div>
      </div>
      {/if}
  </div>
  <div class="columns">
    <div class="column col-12">
      {#if account.name && account.city && account.state && account.zip}
        <div class="card">
          <div class="card-header">
              <div class="tile tile-centered">
              <div class="tile-content">
                  <div class="card-title h6">Z-Tools</div>
              </div>
              <div class="tile-action">
                  <a href="https://ztools.geosync.cloud/installation" target="_blank" class="btn btn-link">Install Help</a>
                  <a href={account.ztools} class="btn btn-primary">Download</a>
              </div>
              </div>
          </div>
          <div class="card-body">
          {#if account.licenses && account.licenses.length > 0}
            <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Computer</th>
                    <th>Expiration</th>
                    <th>Web Share</th>
                  </tr>
                </thead>
                <tbody>
                    {#each account.licenses as license}
                    <tr>
                    <td>{license.code}</td>
                    <td>{license.computer}</td>
                    <td>{license.expires}</td>
                    <td>{license.storage}</td>
                    </tr>
                    {/each}
                </tbody>
            </table>
          {/if}
          </div>
        </div>
      {:else}
        <div class="empty">
          <p class="empty-title h5">Please enter your contact information above to unlock the Z-Tools download and license codes.</p>
        </div>
      {/if}
      <div class="empty">
        <p class="empty-title h5">If you need to make changes to licenses or storage limits, please contact using the link below:</p>
        <div class="empty-action">
          <a href="https://start.geosync.cloud/contact" class="btn btn-primary">Contact Us</a>
        </div>
      </div>
    </div>
  </div>
  {:else}
    <div class="empty" in:fade>
      <div class="empty-icon">
        <i class="svg">{@html contact.md}</i>
      </div>
      <p class="empty-title h5">You are not signed in</p>
      <p class="empty-subtitle">You must be signed in to purchase subscriptions and view account information.</p>
      <p class="empty-subtitle">If you don't have an account, you can create one for free with the button below.</p>
      <div class="empty-action">
        <button class="btn btn-primary" on:click={ function (e) {
            e.currentTarget.blur();
            modal = true
          }}>Sign in</button>
      </div>
    </div>
  {/if}
</div>

<style>
  .card {
    border: 0;
  }
  .table th {
    border-bottom-width: .05rem;
  }
  .contact-field {
    display: inline-block;
    padding-top: 0.2rem;
  }
  .empty {
    background-color: white;
  }
  .empty-icon {
    margin: auto;
    width: 200px;
  }
</style>